// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.hidden {
  display: none;
}

.header-container {
  align-items: center;
  background: white;
  color: #0669B3;
  display: flex;
  height: 80px;
  justify-content: space-between;
  margin-left: 12px;
  max-width: 100%;
  padding: 4px;
}
.header-container .header-dcsd-icon {
  align-items: center;
  display: flex;
  margin-left: 4px;
  margin-right: 36px;
}
.header-container .header-name-container {
  align-items: center;
  display: flex;
  font-size: 1rem;
  font-weight: bold;
  width: 80%;
}
.header-container .header-name-container h5 {
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
}
.header-container .header-position-container {
  margin-left: 4%;
  width: 80%;
}
.header-container .header-position-container h5 {
  font-size: 0.9rem;
  font-weight: 400;
  margin: 0;
}
.header-container .header-right {
  margin-left: auto;
}
.header-container .header-right .nav-button-container {
  align-items: center;
  display: flex;
  height: 72px;
}
.header-container .header-right .nav-button-container .nav-button-links {
  border-radius: 4px;
  padding: 0 15px 0 15px;
  text-transform: lowercase;
}
.header-container .header-right span {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.header-container .header-right span .nav-button-icon {
  padding-left: 10px;
}
.header-container .header-right .nav-button-text {
  color: white;
  font-size: 1em;
  white-space: nowrap;
}
.header-container .header-right .nav-button-text .resources {
  color: white;
  text-decoration: none;
}

.mobile-hamburger {
  display: none;
}

.a-action-button-dup {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  display: flex;
  height: 30px;
  text-decoration: none;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.a-action-button-dup:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.a-action-button-dup:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.resources-links-dropdown .dropdown-toggle::after {
  display: none;
}
.resources-links-dropdown .dropdown-menu {
  z-index: 1050;
  min-width: 280px;
  padding: 0.5rem 0;
  border: 1px solid rgba(6, 105, 179, 0.22);
  border-radius: 4px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.14);
}
.resources-links-dropdown .dropdown-item {
  color: #0669B3;
  font-size: 1.35rem;
  font-weight: 500;
  line-height: 1.35;
  padding: 0.85rem 1.35rem;
  white-space: nowrap;
}
.resources-links-dropdown .dropdown-item i {
  margin-right: 0.45em;
}
.resources-links-dropdown .dropdown-item:hover, .resources-links-dropdown .dropdown-item:focus {
  background: #63AEDE;
  color: white;
}
.resources-links-dropdown .dropdown-item:active {
  background: #0669B3;
  color: white;
}

@media only screen and (max-width: 900px) {
  .mobile-hamburger {
    display: block;
    margin: 5px 25px 0 0;
  }
  .mobile-menu-links a {
    color: #0A4064;
    font-size: 0.85em;
    font-weight: 500;
    margin-left: 10px;
  }
  .nav-button-container {
    display: none !important;
  }
  .header-container {
    display: flex;
    justify-content: space-between;
  }
  .header-name-container h5 {
    margin: 0 2.5rem 0 0;
    font-size: 1em;
  }
  .mobile-menu-bold {
    font-weight: bold;
  }
  .helpful-links-dropdown div a {
    text-decoration: none;
  }
  .mobile-list-hamburger {
    margin-left: 16px;
  }
  .mobile-dropdown-icon {
    padding-right: 10px;
  }
  Button a {
    color: #0A4064;
    padding-left: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Header.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;AAUJ;;AAPA;EACI,mBAAA;EACA,iBAAA;EACA,cDuBS;ECtBT,aAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AAUJ;AARI;EACI,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAUR;AAPI;EACI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AASR;AALQ;EACI,eAAA;EACA,iBAAA;EACA,SAAA;AAOZ;AAHI;EACI,eAAA;EACA,UAAA;AAKR;AAJQ;EACI,iBAAA;EACA,gBAAA;EACA,SAAA;AAMZ;AAFI;EACI,iBAAA;AAIR;AAHQ;EACI,mBAAA;EACA,aAAA;EACA,YAAA;AAKZ;AAHY;EACI,kBAAA;EACA,sBAAA;EACA,yBAAA;AAKhB;AADQ;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGZ;AADY;EACI,kBAAA;AAGhB;AACQ;EACI,YAAA;EACA,cAAA;EACA,mBAAA;AACZ;AAAY;EACI,YAAA;EACA,qBAAA;AAEhB;;AAKA;EACI,aAAA;AAFJ;;AAKA;EC1FI,kBD2FsB;ECtEtB,2CAAA;EDwEA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,mBDlES;ECmET,YAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAFJ;AAII;EACI,uBAAA;EACA,mBD5EW;AC0EnB;AAII;EACI,YAAA;EACA,mBAAA;AAFR;;AAOI;EACI,aAAA;AAJR;AAOI;EACI,aAAA;EAEA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;EACA,0CAAA;AANR;AASI;EACI,cDrGK;ECsGL,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,mBAAA;AAPR;AASQ;EACI,oBAAA;AAPZ;AAUQ;EAEI,mBDhHI;ECiHJ,YAAA;AATZ;AAYQ;EACI,mBDvHC;ECwHD,YAAA;AAVZ;;AAmBA;EACI;IACI,cAAA;IACA,oBAAA;EAhBN;EAmBE;IACI,cDhKE;ICiKF,iBAAA;IACA,gBAAA;IACA,iBAAA;EAjBN;EAoBE;IACI,wBAAA;EAlBN;EAqBE;IACI,aAAA;IACA,8BAAA;EAnBN;EAsBE;IACI,oBAAA;IACA,cAAA;EApBN;EAuBE;IACI,iBAAA;EArBN;EAwBE;IACI,qBAAA;EAtBN;EAyBE;IACI,iBAAA;EAvBN;EA0BE;IACI,mBAAA;EAxBN;EA2BE;IACI,cDrME;ICsMF,iBAAA;EAzBN;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.hidden {\n    display: none;\n}\n\n.header-container {\n    align-items: center;\n    background: white;\n    color: $pearl-blue;\n    display: flex;\n    height: 80px;\n    justify-content: space-between;\n    margin-left: 12px;\n    max-width: 100%;\n    padding: 4px;\n\n    & .header-dcsd-icon {\n        align-items: center;\n        display: flex;\n        margin-left: 4px;\n        margin-right: 36px;\n    }\n\n    .header-name-container {\n        align-items: center;\n        display: flex;\n        font-size: 1rem;\n        font-weight: bold;\n        width: 80%;\n    }\n\n    .header-name-container {\n        & h5 {\n            font-size: 1rem;\n            font-weight: bold;\n            margin: 0;\n        }\n    }\n\n    .header-position-container {\n        margin-left: 4%;\n        width: 80%;\n        h5 {\n            font-size: 0.9rem;\n            font-weight: 400;;\n            margin: 0;\n        }\n    }\n\n    .header-right {\n        margin-left: auto;\n        .nav-button-container {\n            align-items: center;\n            display: flex;\n            height: 72px;\n\n            & .nav-button-links {\n                border-radius: 4px;\n                padding: 0 15px 0 15px;\n                text-transform: lowercase;\n            }\n        }\n\n        span {\n            align-items: center;\n            display: flex;\n            flex-direction: row;\n            justify-content: center;\n\n            & .nav-button-icon {\n                padding-left: 10px;\n            }\n        }\n\n        .nav-button-text {\n            color: white;\n            font-size: 1em;\n            white-space: nowrap;\n            .resources {\n                color: white;\n                text-decoration: none;\n            }\n        }\n\n    }\n}\n\n.mobile-hamburger {\n    display: none;\n}\n\n.a-action-button-dup {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    align-items: center;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    display: flex;\n    height: 30px;\n    text-decoration: none;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:hover {\n        transform: scale(1.015);\n        background: $pearl-blue-hover;\n    }\n    &:disabled {\n        opacity: .5;\n        cursor: not-allowed;\n    }\n}\n\n.resources-links-dropdown {\n    .dropdown-toggle::after {\n        display: none;\n    }\n\n    .dropdown-menu {\n        z-index: 1050;\n        // header-right uses scale(0.7); size up so menu reads ~app-normal after that scale\n        min-width: 280px;\n        padding: 0.5rem 0;\n        border: 1px solid rgba(6, 105, 179, 0.22);\n        border-radius: 4px;\n        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.14);\n    }\n\n    .dropdown-item {\n        color: $pearl-blue;\n        font-size: 1.35rem;\n        font-weight: 500;\n        line-height: 1.35;\n        padding: 0.85rem 1.35rem;\n        white-space: nowrap;\n\n        i {\n            margin-right: 0.45em;\n        }\n\n        &:hover,\n        &:focus {\n            background: $lt-pearl-blue;\n            color: white;\n        }\n\n        &:active {\n            background: $pearl-blue;\n            color: white;\n        }\n    }\n}\n\n//////////////////////////////////////////////////////////////////////////////////////////////\n// MEDIA QUERIES //\n//////////////////////////////////////////////////////////////////////////////////////////////\n\n@media only screen and (max-width: 900px) {\n    .mobile-hamburger {\n        display: block;\n        margin: 5px 25px 0 0;\n    }\n\n    .mobile-menu-links a {\n        color: $dk-blue;\n        font-size: .85em;\n        font-weight: 500;\n        margin-left: 10px;\n    }\n\n    .nav-button-container {\n        display: none !important;\n    }\n\n    .header-container {\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .header-name-container h5 {\n        margin: 0 2.5rem 0 0;\n        font-size: 1em;\n    }\n\n    .mobile-menu-bold {\n        font-weight: bold;\n    }\n\n    .helpful-links-dropdown div a {\n        text-decoration: none;\n    }\n\n    .mobile-list-hamburger {\n        margin-left: 16px;\n    }\n\n    .mobile-dropdown-icon {\n        padding-right: 10px;\n    }\n\n    Button a {\n        color: $dk-blue;\n        padding-left: 5px;\n    }\n\n};\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
